import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

const Navbar = () => {
  return (
    <div className="navbar top-0 left-116 w-full z-10 bg-black relative">
      <Link to="/">
        <div className="relative w-[19em] mt-16 md:mt-16 lg:mt-0 xl:pt-8 md:w-96 lg:w-[23em] xl:w-[23em] pt-4 mb-8 mx-auto">
          <img
            className="w-full"
            src="https://res.cloudinary.com/dzxrdh920/image/upload/v1714442621/vdi2ump2f8xvyhp4bltm.png"
            alt="Logo"
          />
         
        </div>
      </Link>

      <ul className="flex flex-wrap justify-center md:hidden space-x-6 mx-auto mr-4">
        <li>
          <Link to="/Talent" className="text-white text-md text-[0.8em] pl-4 uppercase hover:underline">Talent</Link>
          <Icon icon="material-symbols:arrow-insert" />
        </li>
        <li>
          <Link to="/Team" className="text-white text-md text-[0.8em] pl-4 uppercase hover:underline">Team</Link>
          <Icon icon="material-symbols:arrow-insert" />
        </li>
        <li>
          <Link to="/Partners" className="text-white text-md text-[0.8em] pl-4 uppercase hover:underline">Partners</Link>
          <Icon icon="material-symbols:arrow-insert" />
        </li>
        <li>
          <Link to="https://store.end.xn--mk1bu44c/" className="text-white text-md text-[0.8em] pl-4 uppercase hover:underline">Shop</Link>
          <Icon icon="material-symbols:arrow-insert" />
        </li>
      
        <li>
          <Link to="/About" className="text-white text-md text-[0.8em] pl-4 uppercase hover:underline">About</Link>
          <Icon icon="material-symbols:arrow-insert" />
        </li>
        
      </ul>

      <ul className="hidden md:flex justify-center items-center space-x-8">
     
      
       
        <li>
          <Link to="/Talent" className="text-white text-[1.3em] hover:text-gray-300 hover:underline">Talent</Link>
        </li>
        <li>
          <Link to="/Team" className="text-white text-[1.3em] hover:text-gray-300 hover:underline">Team</Link>
        </li>
        <li>
          <Link to="/Partners" className="text-white text-[1.3em] hover:text-gray-300 hover:underline">Partners</Link>
        </li>
        <li>
          <Link to="https://store.end.xn--mk1bu44c/" className="text-white text-[1.3em] hover:text-gray-300 hover:underline">Shop</Link>
        </li>
        <li>
          <Link to="/About" className="text-white text-[1.3em] hover:text-gray-300 hover:underline">About</Link>
        </li>
       
      </ul>

    </div>
  );
}

export default Navbar;
